<template>
  <div class="research-page">
    <!-- 页面顶部横幅 -->
    <section class="hero-banner" :style="{ backgroundImage: `url(${defaultEnv})` }">
      <div class="banner-overlay">
        <div class="container">
          <h1 class="banner-title">中政量化技术研究院</h1>
          <p class="banner-subtitle">专注于量化研究与技术创新的专业团队</p>
        </div>
      </div>
    </section>

  
    <section class="team-photo-section">
      <div class="container">
        <h2 class="section-title">团队核心成员介绍</h2>
        
        <div class="chief-scientist-container">
          <h3 class="chief-scientist-title">团队首席科学家：梁满发教授</h3>
          <div class="scientist-info">
            <div class="scientist-photo">
              <img src="/jiaoshou.png" alt="梁满发教授" class="scientist-image" style="width: 300px; height: auto; display: block; border-radius: 8px;">
            </div>
            <div class="scientist-details">
              <div class="qualifications">
                <h4 class="qualifications-title">专业资质</h4>
                <ul class="qualification-list">
                  <li>华南理工大学数学学院教授/博士</li>
                  <li>广东省运筹学会秘书长</li>
                  <li>概率论与数理统计专业硕士生导师</li>
                  <li>MCM国际数学建模教练</li>
                </ul>
              </div>
              <div class="expertise">
                <h4 class="expertise-title">专家领域</h4>
                <ul class="expertise-list">
                  <li>大数据与AI专家</li>
                  <li>金融工程专家</li>
                  <li>市场研究专家</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="experience-container">
            <div class="experience-item">
              <div class="experience-icon"><i class="fa fa-line-chart"></i></div>
              <div class="experience-text">
                <span class="experience-number">30年</span>市场研究经验
              </div>
            </div>
            <div class="experience-item">
              <div class="experience-icon"><i class="fa fa-database"></i></div>
              <div class="experience-text">
                <span class="experience-number">20年</span>数据挖掘经验
              </div>
            </div>
            <div class="experience-item">
              <div class="experience-icon"><i class="fa fa-bolt"></i></div>
              <div class="experience-text">
                <span class="experience-number">10年</span>量化投资研究经验
              </div>
            </div>
            <div class="experience-item">
              <div class="experience-icon"><i class="fa fa-users"></i></div>
              <div class="experience-text">
                孵化<span class="experience-number">6家</span>量化投研团队
              </div>
            </div>
          </div>
        </div>
        
        <!-- 其他核心成员介绍 -->
        <div class="core-members-container">
          <h3 class="core-members-title">总经理：郭燚</h3>
          
          <!-- 郭燚 -->
        <div class="scientist-info">
          <div class="scientist-photo">
            <img src="/guoyi.png" alt="郭燚" class="scientist-image">
          </div>
          <div class="scientist-details">
            <div class="qualifications">
              <h4 class="qualifications-title">专业资质</h4>
              <ul class="qualification-list">
                <li>华南理工大学概率与数理统计硕士</li>
                <li>中央财经大学粤港澳大湾区研究院校外硕士导师</li>
                <li>3项大数据发明专利</li>
              </ul>
            </div>
            <div class="expertise">
              <h4 class="expertise-title">研究领域</h4>
              <ul class="expertise-list">
                <li>大数据领域相关技术研发</li>
                <li>AI/大数据企业创立与管理</li>
                <li>数学建模与数据分析</li>
                <li>海量金融数据挖掘</li>
                <li>多模态AI算法与大模型技术</li>
              </ul>
            </div>
            <div class="achievements">
              <h4 class="qualifications-title">主要成就</h4>
              <ul class="qualification-list">
                <li>主导创立迪奥信息、Robot动力科技等大数据与人工智能企业</li>
                <li>获全国研究生数学建模竞赛一等奖</li>
                <li>精通海量金融及多领域数据挖掘技术，高效挖掘数据价值与核心信号</li>
                <li>深耕多模态AI算法与大模型技术，为量化及智能应用提供前沿技术支持</li>
              </ul>
            </div>
          </div>
        </div>
        
        <!-- 经验容器 -->
        <div class="experience-container">
          <div class="experience-item">
            <div class="experience-icon"><i class="fa fa-lightbulb-o"></i></div>
            <div class="experience-text">
              <span class="experience-number">3项</span>大数据发明专利
            </div>
          </div>
          <div class="experience-item">
            <div class="experience-icon"><i class="fa fa-trophy"></i></div>
            <div class="experience-text">
              获<span class="experience-number">全国</span>研究生数学建模竞赛一等奖
            </div>
          </div>
          <div class="experience-item">
            <div class="experience-icon"><i class="fa fa-building"></i></div>
            <div class="experience-text">
              孵化<span class="experience-number">多家</span>大数据与AI企业
            </div>
          </div>
          <div class="experience-item">
            <div class="experience-icon"><i class="fa fa-code"></i></div>
            <div class="experience-text">
              深耕<span class="experience-number">多模态</span>AI算法与大模型技术
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>

    <!-- 为什么选择我们部分 -->
    <section class="why-choose-us-section">
      <div class="container">
        <h2 class="section-title">为什么选择我们</h2>
        <p class="section-description">加入中政量化，开启您的职业新篇章</p>
        <div class="advantages-grid">
          <div class="advantage-item">
              <div class="advantage-icon"><i class="fa fa-graduation-cap"></i></div>
            <h3 class="advantage-title">专业成长</h3>
            <p class="advantage-description">完善的培训体系和晋升通道，与行业顶尖专家共事，持续提升专业能力。</p>
          </div>
          <div class="advantage-item">
              <div class="advantage-icon"><i class="fa fa-laptop"></i></div>
            <h3 class="advantage-title">技术创新</h3>
            <p class="advantage-description">前沿的技术平台和开放的创新环境，激发潜能，引领行业发展。</p>
          </div>
          <div class="advantage-item">
              <div class="advantage-icon"><i class="fa fa-users"></i></div>
            <h3 class="advantage-title">精英团队</h3>
            <p class="advantage-description">汇聚国内顶尖高校和金融机构人才，共同成长，共享成功。</p>
          </div>
        </div>
      </div>
    </section>

   
  

    
  </div>
</template>

<style scoped>
.research-page {
  min-height: 100vh;
}

/* 顶部横幅 */
.hero-banner {
  height: 400px;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-subtitle {
  font-size: 24px;
  font-weight: 300;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 通用部分样式 */
.section-title {
  text-align: center;
  font-size: 42px;
  font-weight: 600;
  color: #1b5fae;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.section-description {
  text-align: center;
  font-size: 18px;
  color: #606266;
  margin-bottom: 60px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.team-photo-section,
.why-choose-us-section,
.employee-voices-section,
.environment-activities-section {
  padding: 80px 0;
}

.chief-scientist-container {
  background: #fff;
  border-radius: 16px;
  padding: 35px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  margin-top: 20px;
}

.chief-scientist-title {
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  color: #1b5fae;
  margin-bottom: 30px;
  letter-spacing: 1px;
}

.core-members-container {
  margin-top: 60px;
  background: #fff;
  border-radius: 16px;
  padding: 35px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.core-members-title {
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  color: #1b5fae;
  margin-bottom: 40px;
  letter-spacing: 1px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e8e8e8;
}

.scientist-info {
  display: flex;
  align-items: flex-start;
  gap: 35px;
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .scientist-info {
    flex-direction: column;
    text-align: center;
  }
}

.scientist-photo {
  flex-shrink: 0;
}

.scientist-image {
  width: 220px;
  height: 280px;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.scientist-details {
  flex: 1;
  display: flex;
  gap: 40px;
}

@media (max-width: 992px) {
  .scientist-details {
    flex-direction: column;
    gap: 20px;
  }
}

.qualifications, .expertise, .achievements {
  flex: 1;
}

.qualifications-title, .expertise-title {
  font-size: 20px;
  font-weight: 600;
  color: #1b5fae;
  margin-bottom: 15px;
  position: relative;
  padding-left: 22px;
}

.qualifications-title::before, .expertise-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background: #304156;
  border-radius: 50%;
}

.qualification-list, .expertise-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.expertise-list li {
  font-size: 17px;
  color: #4c5b66;
  margin-bottom: 12px;
  padding-left: 22px;
  position: relative;
  line-height: 1.6;
}

.qualification-list li {
  font-size: 17px;
  color: #4c5b66;
  margin-bottom: 12px;
  padding-left: 22px;
  position: relative;
  line-height: 1.6;
}

.qualification-list li::before, .expertise-list li::before {
  content: '▶';
  position: absolute;
  left: 0;
  color: #1b5fae;
  font-size: 12px;
}

.experience-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px;
  padding-top: 30px;
  border-top: 1px solid #e8e8e8;
}

.experience-item {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 200px;
}

.experience-icon {
  font-size: 36px;
  color: #1b5fae;
  margin-bottom: 15px;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f5f7fa, #e4e7eb);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(48, 65, 86, 0.15);
}

.experience-text {
  font-size: 16px;
  color: #606266;
  line-height: 1.6;
}

.experience-number {
  font-size: 24px;
  font-weight: 700;
  color: #1b5fae;
  margin: 0 4px;
}

/* 响应式设计 */
@media (max-width: 640px) {
  .chief-scientist-container {
    padding: 25px 20px;
  }
  
  .chief-scientist-title {
    font-size: 26px;
  }
  
  .scientist-image {
    width: 180px;
    height: 220px;
  }
  
  .experience-container {
    flex-direction: column;
    gap: 25px;
  }
  
  .experience-item {
    min-width: auto;
  }
}

/* 优势网格 */
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 60px;
}

.advantage-item {
  text-align: center;
  padding: 40px 30px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.advantage-item:hover {
  transform: translateY(-5px);
}

.advantage-icon {
  font-size: 48px;
  color: #1b5fae;
  margin-bottom: 20px;
}

.advantage-title {
  font-size: 24px;
  font-weight: 600;
  color: #1b5fae;
  margin-bottom: 15px;
}

.advantage-description {
  font-size: 16px;
  color: #606266;
  line-height: 1.6;
}

/* 员工心声 */
.employee-voices-section {
  background: #f8f9fa;
}

.voice-item {
  text-align: center;
  padding: 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.employee-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.employee-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
}

.employee-name {
  font-size: 20px;
  font-weight: 600;
  color: #1b5fae;
  margin-bottom: 5px;
}

.employee-position {
  font-size: 16px;
  color: #606266;
}

.voice-content {
  font-size: 18px;
  color: #606266;
  line-height: 1.8;
  font-style: italic;
}

/* 部门网格样式已删除 */

/* 部门描述样式已删除 */

/* 环境展示 */
.environment-gallery {
  margin-bottom: 60px;
}

.gallery-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.gallery-item {
  text-align: center;
}

.gallery-image {
  width: 100%;
  height: 250px;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.gallery-caption {
  margin-top: 15px;
  font-size: 16px;
  color: #606266;
}

.env-state { text-align:center; padding:40px 0; color:#606266; }
.env-state.error { color:#d93026; }

.activities-showcase {
  margin-top: 60px;
}

.activities-header h3 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: #1b5fae;
  margin-bottom: 40px;
}

.activities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.activity-item {
  text-align: center;
}

.activity-image {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.activity-title {
  margin-top: 15px;
  font-size: 18px;
  font-weight: 600;
  color: #1b5fae;
}

/* 人才计划 */
.talent-program-section { padding: 80px 0; background: #f8f9fb; }
.jobs-toolbar { display:flex; align-items:center; justify-content:space-between; margin-bottom:20px; gap:20px; flex-wrap:wrap; }
.jobs-toolbar .api-path code { background:#fff; padding:4px 8px; border-radius:4px; font-size:12px; border:1px solid #e0e6ed; }
.jobs-loading, .jobs-empty { text-align:center; padding:40px 0; color:#606266; }
.jobs-error { margin:20px 0; }
.jobs-list { display:flex; flex-direction:column; gap:16px; }
.job-item { display:flex; justify-content:space-between; gap:24px; background:#fff; border:1px solid #e6e8ec; border-radius:10px; padding:22px 26px; cursor:pointer; transition:box-shadow .25s, transform .25s; }
.job-item:hover { box-shadow:0 6px 22px rgba(0,0,0,0.08); transform:translateY(-3px); }
.job-main { flex:1; min-width:0; }
.job-title { margin:0 0 10px; font-size:20px; font-weight:600; color:#1b5fae; line-height:1.3; }
.job-summary { margin:0 0 12px; font-size:14px; color:#606266; line-height:1.6; display:-webkit-box; -webkit-line-clamp:2; line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
.job-tags .tag { display:inline-block; background:#f0f5ff; color:#336699; font-size:12px; padding:4px 10px; border-radius:12px; margin-right:8px; margin-bottom:6px; }
.job-meta { display:flex; flex-direction:column; align-items:flex-end; justify-content:space-between; min-width:140px; }
.job-date { font-size:12px; color:#909399; }
@media (max-width: 780px) { .job-item { flex-direction:column; align-items:flex-start; } .job-meta { flex-direction:row; align-items:center; gap:16px; min-width:0; width:100%; } .job-title { font-size:18px; } }

/* 响应式设计 */
@media (max-width: 768px) {
  .banner-title {
    font-size: 36px;
  }
  
  .banner-subtitle {
    font-size: 20px;
  }
  
  .section-title {
    font-size: 32px;
  }
  
  .advantages-grid,
  .gallery-row,
  .activities-grid {
    grid-template-columns: 1fr;
  }
  
  .team-photo {
    height: 250px;
  }
  
  .employee-info {
    flex-direction: column;
    text-align: center;
  }
  
  .employee-avatar {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>

<script>
export default {
  name: 'ResearchPage',
  data() {
    return {
      defaultEnv: '/zhuyetupian.jpg'
    }
  },
  mounted() {
    // 这里可以添加获取环境照片的逻辑
    // 暂时保持为空数组，显示"暂无图片"
  }
}
</script>